export default {
  type: 'menu',
  code: '13000000'
}
